import React, { useState, useEffect } from 'react';
import '../../../../assests/css/customer/AccCaro.css';
import re1 from '../../../../assests/images/re1.jpg';
import re2 from '../../../../assests/images/re2.jpg';
import re3 from '../../../../assests/images/re3.jpg';
import re4 from '../../../../assests/images/re4.jpg';


const AccCaro = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: re1,
      title: 'READY TO WEAR',
      description: 'Experience the quintessence of enduring artistry and elegance crafted to perfection.',
      layout: 'imageLeft'
    },
    {
      id: 2,
      image: re2,
      title: 'LUXURY COLLECTION',
      description: 'Discover our exclusive range of premium accessories designed for the modern woman.',
      layout: 'textLeft'
    },
    {
      id: 3,
      image: re3,
      title: 'TRADITIONAL ELEGANCE',
      description: 'Embrace timeless beauty with our handcrafted traditional wear collection.',
      layout: 'imageLeft'
    },
    {
      id: 4,
      image: re4,
      title: 'SUMMER COLLECTION',
      description: 'Light, breezy and vibrant designs perfect for the sunny season.',
      layout: 'textLeft'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const handleImageClick = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const handleNavigate = () => {
    window.location.href = '/her';
  };

  return (
    <div className="AccessoriesHomeCard-carousel-container">
      <div className="AccessoriesHomeCard-carousel-wrapper">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`AccessoriesHomeCard-slide ${
              index === currentSlide ? 'AccessoriesHomeCard-active' : ''
            } ${slide.layout === 'textLeft' ? 'AccessoriesHomeCard-reverse' : ''}`}
          >
            <div 
              className="AccessoriesHomeCard-image-section"
              onClick={handleImageClick}
            >
              <img
                src={slide.image}
                alt={slide.title}
                className="AccessoriesHomeCard-image"
              />
            </div>

            <div className="AccessoriesHomeCard-content-section">
              <div className="AccessoriesHomeCard-content-wrapper">
                <h2 className="AccessoriesHomeCard-title">{slide.title}</h2>
                <p className="AccessoriesHomeCard-description">
                  {slide.description}
                </p>
                <button
                  onClick={handleNavigate}
                  className="AccessoriesHomeCard-discover-button"
                >
                  Discover Now
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="AccessoriesHomeCard-dots-container">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            className={`AccessoriesHomeCard-dot ${
              index === currentSlide ? 'AccessoriesHomeCard-dot-active' : ''
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AccCaro;